import React from "react"
import styled from "styled-components"
import FlexContainer from "../FlexContainer"

const BODY_FONT_SIZE = "16px"
const MOBILE_BODY_FONT_SIZE = "15px"
const MOBILE_CONTENT_WIDTH = "360px"
const PriceContainer = styled.div`
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 6px;
  }
`

const HaircutPriceContainer = styled(PriceContainer)`
  width: min(100%, 350px);
  margin-bottom: 0;

  @media (max-width: 768px) {
    width: min(100%, ${MOBILE_CONTENT_WIDTH});
    margin: 0 auto 8px;
  }
`

const HaircutTimedRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 50px 42px;
  gap: 0.2rem;
  align-items: baseline;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr) 46px 40px;
    gap: 0.2rem;
  }
`

const HaircutSimpleRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px;
  gap: 0.2rem;
  align-items: baseline;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr) 40px;
    gap: 0.2rem;
  }
`

const ItemSmall = styled.p`
  text-align: ${props => (props.textAlign === "center" ? "center" : "left")};
  font-size: 13px;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 0.35rem;
  }
`
const PricingHeader = styled.h3`
  margin: 1rem 0 0.4rem;
  text-align: center;

  @media (max-width: 768px) {
    text-align: center;
    margin: 0 0 0.55rem;
  }
`

const ColorPriceWrap = styled.div`
  width: min(100%, 560px);
  margin: 0 auto;

  @media (max-width: 768px) {
    width: min(100%, ${MOBILE_CONTENT_WIDTH});
  }
`

const ColorSinglePriceRow = styled.div`
  display: grid;
  grid-template-columns: minmax(250px, auto) 185px;
  justify-content: center;
  gap: 0.65rem;
  align-items: baseline;
  margin-bottom: 0.3rem;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr) auto;
    justify-content: stretch;
    gap: 0.1rem;
  }
`

const WashCareWrap = styled(ColorPriceWrap)`
  width: min(100%, 450px);
`

const WashCareRow = styled(ColorSinglePriceRow)``

const WashCareNote = styled.p`
  width: min(100%, calc(250px + 185px + 0.65rem));
  margin: 0 auto 0.55rem;
  font-size: 11px;
  font-style: italic;

  @media (max-width: 768px) {
    width: 100%;
    margin: 0 auto 0.55rem;
  }
`

const ColorThreeColHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(250px, auto) repeat(3, 52px);
  justify-content: center;
  gap: 0.55rem;
  align-items: end;
  margin: 1.9rem 0 0.7rem;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    grid-template-columns: minmax(130px, 1fr) repeat(3, 48px);
    justify-content: stretch;
    gap: 0.3rem;
    font-size: 0.8rem;
    margin: 1.9rem 0 0.7rem;
  }
`

const ColorThreeColRow = styled.div`
  display: grid;
  grid-template-columns: minmax(250px, auto) repeat(3, 52px);
  justify-content: center;
  gap: 0.55rem;
  align-items: baseline;

  @media (max-width: 768px) {
    grid-template-columns: minmax(130px, 1fr) repeat(3, 48px);
    justify-content: stretch;
    gap: 0.3rem;
  }
`

const ColorLabel = styled.p`
  margin: 0px;
  font-size: ${BODY_FONT_SIZE};

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
  }
`

const ColorValue = styled.p`
  margin: 0;
  font-size: ${BODY_FONT_SIZE};
  text-align: right;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
  }
`

const ColorHeaderValue = styled.p`
  margin: 0;
  width: max-content;
  font-size: 13px;
  text-align: center;
  justify-self: center;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 12px;
    text-align: center;
    justify-self: center;
    transform: none;
  }
`

const ColorTableValue = styled(ColorValue)`
  text-align: center;
  justify-self: center;
`

const ColorNote = styled.p`
  margin: 0.7rem 0 0;
  font-size: ${BODY_FONT_SIZE};
  font-style: ${props => (props.italic ? "italic" : "normal")};
  justify-content: center;

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
    margin-top: 0.65rem;
  }
`

const ColorNoteRow = styled(ColorSinglePriceRow)`
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    margin-top: 1rem;
  }
`

const ServiceColumns = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  padding-top: 1.2rem;
  padding-bottom: 0.85rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.85rem;
    padding-top: 0.75rem;
    padding-bottom: 12px;
  }
`

const HaircutSection = styled(FlexContainer)`
  gap: 3.25rem;
  padding-bottom: 0.30rem;

  @media (max-width: 768px) {
    gap: 0.35rem;
    padding-bottom: 12px;
  }
`

const PricingSection = styled(FlexContainer)`
  padding-bottom: 0.25rem;

  @media (max-width: 768px) {
    padding-bottom: 12px;
  }
`

const ServiceColumn = styled.div`
  width: min(100%, 380px);

  @media (max-width: 768px) {
    width: min(100%, ${MOBILE_CONTENT_WIDTH});
    margin: 0 auto;
    padding-bottom: 0.4rem;
  }
`

const ServiceColumnHeader = styled.h3`
  margin: 0 0 1rem;
  text-align: center;

  @media (max-width: 768px) {
    margin-bottom: 0.5rem;
  }
`

const ServiceSingleRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem;
  align-items: baseline;
  margin-bottom: 0.15rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`

const ServiceLabel = styled.p`
  margin: 0;
  font-size: ${BODY_FONT_SIZE};

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
  }
`

const ServicePrice = styled.p`
  margin: 0;
  font-size: ${BODY_FONT_SIZE};
  text-align: right;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
  }
`

const PermanentHeaderRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem;
  align-items: end;
  margin: 0.35rem 0 0.25rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`

const PermanentHeaderText = styled.p`
  margin: 0;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
`

const ServiceSpacer = styled.div`
  height: 1rem;
`

const HaircutLabel = styled.p`
  margin: 0;
  font-size: ${BODY_FONT_SIZE};

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
  }
`

const HaircutMeta = styled.p`
  margin: 0;
  font-size: ${BODY_FONT_SIZE};
  text-align: right;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: ${MOBILE_BODY_FONT_SIZE};
  }
`

const Pricing = () => (
  <div
    className="pricing"
    id="pricelist"
    style={{
      backgroundColor: `#e7e7e748`,
      margin: `0 auto`,
      maxWidth: 960,
      padding: `2rem 1.45rem 5rem 1.45rem`,
    }}
  >
    <h1
      style={{
        textAlign: `center`,
        marginBottom: `0`,
      }}
    >
      Hinnasto
    </h1>
    <p
      style={{
        textAlign: `center`,
        fontSize: `11px`,
      }}
    >
      (sis. alv 25,5%)
    </p>
    <hr />
    <PricingHeader>Hiustenleikkaus</PricingHeader>
    <HaircutSection justifyContent="center" paddingBottom="40px">
      <HaircutPriceContainer>
        <ItemSmall style={{ fontStyle: `italic` }}>
          sisältää pesun ja muotoonkuivauksen:
        </ItemSmall>
        <HaircutTimedRow>
          <HaircutLabel>Parturileikkaus</HaircutLabel>
          <HaircutMeta>30 min</HaircutMeta>
          <HaircutMeta>32€</HaircutMeta>
        </HaircutTimedRow>
        <HaircutTimedRow>
          <HaircutLabel>Parturileikkaus</HaircutLabel>
          <HaircutMeta>40 min</HaircutMeta>
          <HaircutMeta>41€</HaircutMeta>
        </HaircutTimedRow>
        <HaircutTimedRow>
          <HaircutLabel>Kampaamoleikkaus</HaircutLabel>
          <HaircutMeta>45 min</HaircutMeta>
          <HaircutMeta>46€</HaircutMeta>
        </HaircutTimedRow>
        <HaircutTimedRow>
          <HaircutLabel>Kampaamoleikkaus</HaircutLabel>
          <HaircutMeta>60 min</HaircutMeta>
          <HaircutMeta>59€</HaircutMeta>
        </HaircutTimedRow>
        <HaircutTimedRow>
          <HaircutLabel>Kampaamoleikkaus</HaircutLabel>
          <HaircutMeta>75 min</HaircutMeta>
          <HaircutMeta>74€</HaircutMeta>
        </HaircutTimedRow>
      </HaircutPriceContainer>
      <HaircutPriceContainer>
        <ItemSmall style={{ fontStyle: `italic` }}>
          ei sisällä pesua tai muotoonkuivausta:
        </ItemSmall>
        <HaircutSimpleRow>
          <HaircutLabel>Pitkien hiusten tasausleikkaus</HaircutLabel>
          <HaircutMeta>30€</HaircutMeta>
        </HaircutSimpleRow>
        <HaircutSimpleRow>
          <HaircutLabel>Lastenleikkaus (0-9 vuotta)</HaircutLabel>
          <HaircutMeta>27€</HaircutMeta>
        </HaircutSimpleRow>
        <HaircutSimpleRow>
          <HaircutLabel>Koneajo</HaircutLabel>
          <HaircutMeta>17€</HaircutMeta>
        </HaircutSimpleRow>
        <HaircutSimpleRow>
          <HaircutLabel>Parran/Viiksien muotoilu</HaircutLabel>
          <HaircutMeta>17€</HaircutMeta>
        </HaircutSimpleRow>
        <HaircutSimpleRow>
          <HaircutLabel>Otsatukan leikkaus</HaircutLabel>
          <HaircutMeta>14€</HaircutMeta>
        </HaircutSimpleRow>
      </HaircutPriceContainer>
    </HaircutSection>

    <PricingHeader>Pesu / Hiushoito</PricingHeader>
    <PricingSection justifyContent="center" paddingBottom="72px">
      <WashCareWrap>
        <WashCareRow>
          <ColorLabel>Pesu ja kuivaus</ColorLabel>
          <ColorValue>20€</ColorValue>
        </WashCareRow>
        <WashCareRow>
          <ColorLabel>Pesu ja muotoonkuivaus</ColorLabel>
          <ColorValue>36€</ColorValue>
        </WashCareRow>
        <WashCareRow>
          <ColorLabel>Hiushoito</ColorLabel>
          <ColorValue>40€</ColorValue>
        </WashCareRow>
          <WashCareNote>
            (sis. hoidon, hiuspohjan hieronnan, pesun ja muotoonkuivauksen)
          </WashCareNote>
      </WashCareWrap>
    </PricingSection>

    <PricingHeader>Väri</PricingHeader>
    <PricingSection justifyContent="center" paddingBottom="72px">
      <ColorPriceWrap>
        <ColorSinglePriceRow>
          <ColorLabel>Tyviväri (max 3cm)</ColorLabel>
          <ColorValue>70€</ColorValue>
        </ColorSinglePriceRow>
        <ColorSinglePriceRow>
          <ColorLabel>Tyviväri ja leikkaus</ColorLabel>
          <ColorValue>100€</ColorValue>
        </ColorSinglePriceRow>
        <ColorSinglePriceRow>
          <ColorLabel>Tyvivaalennus (max 3cm)</ColorLabel>
          <ColorValue>100€</ColorValue>
        </ColorSinglePriceRow>
        <ColorSinglePriceRow>
          <ColorLabel>Tyvivaalennus ja leikkaus</ColorLabel>
          <ColorValue>120€</ColorValue>
        </ColorSinglePriceRow>

        <ColorThreeColHeader>
          <div></div>
          <ColorHeaderValue>lyhyet</ColorHeaderValue>
          <ColorHeaderValue>keskipitkät</ColorHeaderValue>
          <ColorHeaderValue>pitkät</ColorHeaderValue>
        </ColorThreeColHeader>

        <ColorThreeColRow>
          <ColorLabel>Väri</ColorLabel>
          <ColorTableValue>78€</ColorTableValue>
          <ColorTableValue>91€</ColorTableValue>
          <ColorTableValue>102€</ColorTableValue>
        </ColorThreeColRow>
        <ColorThreeColRow>
          <ColorLabel>Väri ja leikkaus</ColorLabel>
          <ColorTableValue>108€</ColorTableValue>
          <ColorTableValue>122€</ColorTableValue>
          <ColorTableValue>126€</ColorTableValue>
        </ColorThreeColRow>
        <ColorThreeColRow>
          <ColorLabel>Kiiltosävy</ColorLabel>
          <ColorTableValue>57€</ColorTableValue>
          <ColorTableValue>70€</ColorTableValue>
          <ColorTableValue>80€</ColorTableValue>
        </ColorThreeColRow>
        <ColorThreeColRow>
          <ColorLabel>Kiiltosävy ja leikkaus</ColorLabel>
          <ColorTableValue>87€</ColorTableValue>
          <ColorTableValue>101€</ColorTableValue>
          <ColorTableValue>107€</ColorTableValue>
        </ColorThreeColRow>

        <ColorThreeColRow style={{ marginTop: "1.2rem" }}>
          <ColorLabel>Moniväri</ColorLabel>
          <ColorTableValue>107€</ColorTableValue>
          <ColorTableValue>134€</ColorTableValue>
          <ColorTableValue>148€</ColorTableValue>
        </ColorThreeColRow>
        <ColorThreeColRow>
          <ColorLabel>Moniväri ja leikkaus</ColorLabel>
          <ColorTableValue>126€</ColorTableValue>
          <ColorTableValue>148€</ColorTableValue>
          <ColorTableValue>163€</ColorTableValue>
        </ColorThreeColRow>
        <ColorThreeColRow>
          <ColorLabel>Raidat</ColorLabel>
          <ColorTableValue>94€</ColorTableValue>
          <ColorTableValue>121€</ColorTableValue>
          <ColorTableValue>136€</ColorTableValue>
        </ColorThreeColRow>
        <ColorThreeColRow>
          <ColorLabel>Raidat ja leikkaus</ColorLabel>
          <ColorTableValue>119€</ColorTableValue>
          <ColorTableValue>137€</ColorTableValue>
          <ColorTableValue>149€</ColorTableValue>
        </ColorThreeColRow>

        <ColorNoteRow>
          <ColorLabel>Vaalennuskäsittely / Värinpoisto</ColorLabel>
          <ColorValue>61€/h</ColorValue>
        </ColorNoteRow>
        <ColorNoteRow>
          <ColorLabel>Extrapitkät / Paksut hiukset</ColorLabel>
          <ColorValue>+ 5-20€</ColorValue>
        </ColorNoteRow>
        <ColorNote italic style={{ marginTop: "1.7rem", textAlign: "center"}}>
          Olethan yhteydessä jos haluat suuren värimuutoksen tai värinpoiston.
        </ColorNote>
      </ColorPriceWrap>
    </PricingSection>

    <ServiceColumns>
      <ServiceColumn>
        <ServiceColumnHeader>Permanentti</ServiceColumnHeader>
        <ServiceSingleRow>
          <ServiceLabel>Permanentti ja Leikkaus (päälliosa)</ServiceLabel>
          <ServicePrice>96€</ServicePrice>
        </ServiceSingleRow>
        <PermanentHeaderRow>
          <div></div>
          <PermanentHeaderText>lyhyet / keskipitkät</PermanentHeaderText>
        </PermanentHeaderRow>
        <ServiceSingleRow>
          <ServiceLabel>Permanentti ja Leikkaus (koko pää)</ServiceLabel>
          <ServicePrice>115€ / 132€</ServicePrice>
        </ServiceSingleRow>
        <ServiceSpacer />
        <ServiceSingleRow>
          <ServiceLabel>+ Sävytys/Kevytväri</ServiceLabel>
          <ServicePrice>alk. 16€</ServicePrice>
        </ServiceSingleRow>
      </ServiceColumn>

      <ServiceColumn>
        <ServiceColumnHeader>Ripset ja kulmat</ServiceColumnHeader>
        <ServiceSingleRow>
          <ServiceLabel>Kulmien värjäys</ServiceLabel>
          <ServicePrice>16€</ServicePrice>
        </ServiceSingleRow>
        <ServiceSingleRow>
          <ServiceLabel>Ripsien värjäys</ServiceLabel>
          <ServicePrice>19€</ServicePrice>
        </ServiceSingleRow>
        <ServiceSingleRow>
          <ServiceLabel>Ripsien ja kulmien värjäys</ServiceLabel>
          <ServicePrice>27€</ServicePrice>
        </ServiceSingleRow>
        <ServiceSpacer />
        <ServiceSingleRow>
          <ServiceLabel>Kulmien muotoilu</ServiceLabel>
          <ServicePrice>16€</ServicePrice>
        </ServiceSingleRow>
        <ServiceSingleRow>
          <ServiceLabel>Kulmien värjäys ja muotoilu</ServiceLabel>
          <ServicePrice>26€</ServicePrice>
        </ServiceSingleRow>
        <ServiceSingleRow>
          <ServiceLabel>Ripsien ja kulmien värjäys ja muotoilu</ServiceLabel>
          <ServicePrice>32€</ServicePrice>
        </ServiceSingleRow>
      </ServiceColumn>
    </ServiceColumns>
  </div>
)

export default Pricing

